import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

type DeleteTagRequest = {
  tagId: string;
  recursive?: boolean;
  hardDelete?: boolean;
};

export const deleteTagApi = async ({ tagId, recursive = true, hardDelete = true }: DeleteTagRequest): Promise<void> => {
  try {
    await openMetadataApiClient.delete(`/tags/${tagId}`, {
      params: {
        recursive,
        hardDelete,
      },
    });
  } catch (error) {
    console.error('Failed to delete tag:', error);
    throw error;
  }
};

export type { DeleteTagRequest };
